<template>
  <div class="kpt-configurator" v-if="hasLoaded">
    <configurator-nav />
    <b-tabs class="has-hidden-tabs has-no-padding configurator-tabs" v-model="activeTab">
      <b-tab-item>
        <div class="kpt-configurator-splash">
          <div style="max-width: 50%;">
            <div class="splash-terminal-wrapper">
              <img class="splash-terminal-box" :src="require('@/assets/configurator/u8terminal.png')" alt="u8 Terminal">
              <img class="splash-terminal-antenna" :src="require('@/assets/configurator/u8-antenna.png')" alt="u8 Antenna" />
            </div>
            
            <div class="is-flex is-justify-content-space-between mt-6 px-6">
              <div style="width: 46%">
                <p class="has-text-black-bis has-text-weight-semibold has-text-centered mb-3">Start here!</p>
                <b-button rounded expanded type="is-dark" class="is-uppercase" @click="goToConfigureBundle">Configure Bundle</b-button>
              </div>
              <div style="width: 46%">
                <p class="has-text-black-bis has-text-weight-semibold has-text-centered mb-3">Additional products</p>
                <b-button disabled rounded expanded type="is-dark" class="is-uppercase">Coming Soon</b-button>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item>
        <configurator-terminal />
      </b-tab-item>
      <b-tab-item>
        <configurator-shopping-cart />
      </b-tab-item>
      <b-tab-item>
        <configurator-accessories />
      </b-tab-item>
      <b-tab-item>
        <configurator-contact-us />
      </b-tab-item>
    </b-tabs>
  </div>
  <div class="container kpt-configurator-load" v-else>
    <div class="box">
      <div class="kpt-loader"><b-loading :is-full-page="false" :active="!hasLoaded" :can-cancel="false"></b-loading></div>
      <div class="has-text-centered">Loading...</div>
    </div>
  </div>
</template>
<script>
import { 
  ref, 
  computed, 
  watch, 
  getCurrentInstance 
} from 'vue';
import ConfiguratorNav from './ConfiguratorNav.vue';
import ConfiguratorTerminal from './ConfiguratorTerminal.vue';
import ConfiguratorShoppingCart from './ConfiguratorShoppingCart.vue';
import ConfiguratorContactUs from './ConfiguratorContactUs.vue';
import ConfiguratorAccessories from './ConfiguratorAccessories.vue';

export default {
  components: {
    ConfiguratorNav,
    ConfiguratorTerminal,
    ConfiguratorShoppingCart,
    ConfiguratorContactUs,
    ConfiguratorAccessories
  },
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const am = computed(() => root.$store.getters['configurator/analyticsMetadata']);
    const activeTab = computed(() => root.$store.state.configurator.activePage);
    const configPermissions = computed(() => root.$store.getters['configurator/configuratorPermissions']);
    const hasLoaded = ref(true);

    const goToConfigureBundle = () => {
      root.$kya.event('configurator', 'openConfigureTerminalFromHome', 'Started terminal configuration from the homepage.', am.value);
      root.$store.commit('configurator/setActivePage', 1);
    }

    const goToAccessories = () => {
      root.$kya.event('configurator', 'openAccessoriesFromHome', 'Clicked on Accessories & FRUs on Configurator homepage.', am.value);
      root.$store.commit('configurator/setActivePage', 3);
    }

    watch(configPermissions, () => {
      if (!configPermissions.value.configuratorVisible) {
        root.$router.push('/home');
      }
      if (!configPermissions.value.msrpPricesVisible) {
        root.$store.commit('configurator/setShowPricesFlag', false);
      }
      if (!configPermissions.value.wholesalePricesVisible) {
        root.$store.commit('configurator/setWholesaleFlag', false);
      }
      if (!configPermissions.value.commercialPriceBook) {
        root.$store.commit('configurator/setCommercialPricebookFlag', false);
      }
      if (!configPermissions.value.militaryPriceBook) {
        root.$store.commit('configurator/setMilitaryPricebookFlag', false);
      }
    });

    (async () => {
      hasLoaded.value = false;
      await root.$store.dispatch('configurator/fetchProducts');
      await root.$store.dispatch('fetchMe');
      hasLoaded.value = true;
      root.$store.commit('configurator/setSessionId'); // set the session id for this configurator session -- used in event tracking
    })();

    return {
      hasLoaded,
      activeTab,
      goToConfigureBundle,
      goToAccessories
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/colors';

.kpt-configurator-load {
  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    height: 140px;
    width: 250px;
    padding: 0px;
    border: none;
    box-shadow: none;

    .kpt-loader {
      position: relative;
      height: 100px;
      width: 250px;
    }
  }
}

.kpt-configurator {
  background: $white-ter;
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .kpt-configurator-splash {
    display: grid;
    place-items: center;
    height: 100%;

    .splash-terminal-wrapper {
      position: relative;

      .splash-terminal-box {
        position: absolute;
        right: 0;
        top: -20%;
      }
    }
  }

  .configurator-tabs {
    flex: 1 0 auto;
    position: relative;
    //max-height: 100%;
    height: 0;
  }

  .kpt-configurator-wholesale {
    position: fixed;
    top: 0.5rem;
    right: 3.5rem;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    background-color: white;
    color: black;
    display: grid;
    place-items: center;    
  }
}
</style>
<style lang="scss">
@import '../styles/colors';

.kpt-configurator {
  color: $black-bis;
}
.configurator-tabs {
  position: relative;
  height: calc(100% - 48px);
  .tab-content {
    height: 100%;;
    .tab-item {
      height: 100%;
    }    
  }
}
</style>
